export default __webpack_public_path__ + "static/media/inward2.befa1533.svg";